import { AvvirEvent } from "type_aliases";

export type PageViewEndedEvent = AvvirEvent<typeof PAGE_VIEW_ENDED, {
  page: string,
  durationMs: number
}>

const pageViewEnded = (page: string, durationMs: number): PageViewEndedEvent => ({
  type: PAGE_VIEW_ENDED,
  payload: { page, durationMs }
});

export const PAGE_VIEW_ENDED = "page_view_ended";

export default pageViewEnded;
